import { AutopilotTaskDto } from '@urbanx/agx.activities.client';
import { CampaignDetailModel } from '@urbanx/agx.campaigns.client';
import TaskModalDialog from './TaskModalDialog';
import { useAgreementComplianceModal } from './useAgreementComplianceModal';

interface AgreementComplianceModalProps {
  campaignId: string;
  campaign: CampaignDetailModel;
  isOpen: boolean;
  onClose: () => void;
  onCompleteSuccess?: () => void;
  tasks: AutopilotTaskDto[];
}

const OpenAgreementComplianceModal = ({
  campaignId,
  campaign,
  isOpen,
  onClose,
  onCompleteSuccess,
  tasks,
}: AgreementComplianceModalProps) => {
  const { contentConfig } = useAgreementComplianceModal({
    campaignId,
    campaign,
    isOpen,
    tasks,
  });

  return (
    <TaskModalDialog
      title={'Agreement Compliance'}
      tasks={tasks}
      open={isOpen}
      onClose={onClose}
      campaignId={campaignId}
      campaign={campaign}
      contentConfig={{
        ...contentConfig,
        onCompleteSuccess,
        hideTaskMetadata: true,
        hideCloseButton: true,
        previousButtonText: 'Previous',
        presentationClassName: 'taskModal--agreementCompliance',
      }}
    />
  );
};

const AgreementComplianceModal = (props: AgreementComplianceModalProps) => {
  if (!props.isOpen) return null;

  return <OpenAgreementComplianceModal {...props} />;
};

export default AgreementComplianceModal;
